import { Issuer } from '../../types/issuer/response';
import { SubscriptionType } from '../../types/subscriptionType/response';

export const LOADING_ISSUERS = 'LOADING_ISSUERS';
export const ADD_ISSUERS = 'ADD_ISSUERS';
export const ISSUERS_ERROR = 'ISSUERS_ERROR';

export interface LoadingIssuers {
  type: typeof LOADING_ISSUERS;
}

export interface AddIssuers {
  type: typeof ADD_ISSUERS;
  issuers: Issuer[];
}

export interface IssuersError {
  type: typeof ISSUERS_ERROR;
  error: string;
}

export type IssuersTypes = LoadingIssuers | AddIssuers | IssuersError;

export const SUBSCRIBING = 'SUBSCRIBING';
export const SUBSCRIBE_SUCCESS = 'SUBSCRIBE_SUCCESS';
export const SUBSCRIBE_ERROR = 'SUBSCRIBE_ERROR';
export const REPLACING_PAYMENT_METHOD = 'REPLACING_PAYMENT_METHOD';
export const REPLACE_PAYMENT_METHOD_SUCCESS = 'REPLACE_PAYMENT_METHOD_SUCCESS';
export const REPLACE_PAYMENT_METHOD_ERROR = 'REPLACE_PAYMENT_METHOD_ERROR';
export const REGISTERING_SUBSCRIBER = 'REGISTERING_SUBSCRIBER';
export const REGISTER_SUBSCRIBER_SUCCESS = 'REGISTER_SUBSCRIBER_SUCCESS';
export const REGISTER_SUBSCRIBER_ERROR = 'REGISTER_SUBSCRIBER_ERROR';
export const FORCING_SUBSCRIPTION_PAYMENT = 'FORCING_SUBSCRIPTION_PAYMENT';
export const FORCE_SUBSCRIPTION_PAYMENT_SUCCESS = 'FORCE_SUBSCRIPTION_PAYMENT_SUCCESS';
export const FORCE_SUBSCRIPTION_PAYMENT_ERROR = 'FORCE_SUBSCRIPTION_PAYMENT_ERROR';

export interface Subscribing {
  type: typeof SUBSCRIBING;
}

export interface SubscribeSuccess {
  type: typeof SUBSCRIBE_SUCCESS;
}

export interface SubscribeError {
  type: typeof SUBSCRIBE_ERROR;
  error: string;
}

export interface ReplacingPaymentMethod {
  type: typeof REPLACING_PAYMENT_METHOD;
}

export interface ReplacePaymentMethodSuccess {
  type: typeof REPLACE_PAYMENT_METHOD_SUCCESS;
  replacePaymentMethodPlexoUrl: string;
}

export interface ReplacePaymentMethodError {
  type: typeof REPLACE_PAYMENT_METHOD_ERROR;
  error: string;
}

export interface registeringSubscriber {
  type: typeof REGISTERING_SUBSCRIBER;
}

export interface RegisterSubscriberSuccess {
  type: typeof REGISTER_SUBSCRIBER_SUCCESS;
  plexoUrl: string;
}

export interface RegisterSubscriberError {
  type: typeof REGISTER_SUBSCRIBER_ERROR;
  error: string;
}

export interface ForcingSubscriptionPayment {
  type: typeof FORCING_SUBSCRIPTION_PAYMENT;
}

export interface ForceSubscriptionPaymentSuccess {
  type: typeof FORCE_SUBSCRIPTION_PAYMENT_SUCCESS;
}

export interface ForceSubscriptionPaymentError {
  type: typeof FORCE_SUBSCRIPTION_PAYMENT_ERROR;
  error: string;
}

export type SubscribeTypes =
  | Subscribing
  | SubscribeSuccess
  | SubscribeError
  | ReplacingPaymentMethod
  | ReplacePaymentMethodSuccess
  | ReplacePaymentMethodError
  | registeringSubscriber
  | RegisterSubscriberSuccess
  | RegisterSubscriberError
  | ForcingSubscriptionPayment
  | ForceSubscriptionPaymentSuccess
  | ForceSubscriptionPaymentError;

export const LOADING_SUBSCRIPTION_TYPES = 'LOADING_SUBSCRIPTION_TYPES';
export const SUBSCRIPTION_TYPES_SUCCESS = 'SUBSCRIPTION_TYPES_SUCCESS';
export const SUBSCRIPTION_TYPES_ERROR = 'SUBSCRIPTION_TYPES_ERROR';

export const SELECT_SUBSCRIPTION_TYPE = 'SELECT_SUBSCRIPTION_TYPE';

export interface LoadingSubscriptionTypes {
  type: typeof LOADING_SUBSCRIPTION_TYPES;
}

export interface SubscriptionTypesSuccess {
  type: typeof SUBSCRIPTION_TYPES_SUCCESS;
  subscriptionTypes: SubscriptionType[];
  selectedSubscriptionType: SubscriptionType | null;
}

export interface SubscriptionTypesError {
  type: typeof SUBSCRIPTION_TYPES_ERROR;
  error: string;
}

export interface SelectSubscriptionType {
  type: typeof SELECT_SUBSCRIPTION_TYPE;
  subscriptionTypeId: string;
}

export type SubscriptionTypes =
  | LoadingSubscriptionTypes
  | SubscriptionTypesSuccess
  | SubscriptionTypesError
  | SelectSubscriptionType;

export type AppActions = IssuersTypes | SubscribeTypes | SubscriptionTypes;
